import React, { Component } from 'react';
import { main } from './sponsors.json'

function Main() {
    return (
        <div className="main-sponsors">
            <h3>UNTERSTÜTZT VON</h3>
            {
                main.map((sponsor, index) =>
                    <div key={index} className="womix__image-wrapper">
                        <a href={sponsor.url} target="_blank">
                            {sponsor.image && <img src={`${sponsor.image}`} alt={sponsor.name} />}
                            {sponsor.text && <h4>{sponsor.text}</h4>}
                        </a>
                    </div>
                )
            }
        </div>
    )
}

export default Main;